// This is a temp file until we can find a better place
import type { ContextData, InputMaybe } from '@adminhub/schema-types';

import { AnalyticsWebClient } from './analytics-client';
import { responseFetchSizeEvent } from './analytics-event-data/analytics-event-data';

export const enum GraphqlQueryNames {
  ORGANIZATION_WORKSPACES_QUERY = 'OrganizationWorkspacesQuery',
  WORKSPACES_RELATED_QUERY = 'WorkspacesRelatedQuery',
  MIGRATION_USER_PROFILE = 'MigrationUserProfile',
  CUSTOM_DOMAINS_USER_DETAILS_QUERY = 'CustomDomainsUserDetailsQuery',
  ORGANIZATION_WORKSPACES_TOTAL_COUNT_QUERY = 'OrganizationWorkspacesTotalCountQuery',
  ORG_USER_DETAILS_QUERY = 'OrgUserDetailsQuery',
  FREE_WORKSPACES_QUERY = 'FreeWorkspacesQuery',
  RELATED_WORKSPACES_QUERY = 'RelatedWorkspacesQuery',
  BRIE_USER_DETAILS_QUERY = 'brieUserDetailsQuery',
  MIRGRATION_SHARED_EXPERIENCES_PROFILE = 'MigrationSharedExperiencesUserProfile',
  SELECT_PRODUCT_TABLE_QUERY = 'SelectProductTableQuery',
  USER_ACCESS_WORKSPACES_QUERY = 'UserAccessWorkspacesQuery',
  UNIFIED_ORGANIZATION_WORKSPACES_FILTER_QUERY = 'UnifiedOrganizationWorkspacesFilterQuery',
  ELIGIBLE_WORKSPACES_QUERY = 'EligibleWorkspacesQuery',
  USER_LIST_TABLE_QUERY = 'UserListTableQuery',
  WORKSPACES_COLLECTIONS_QUERY = 'WorkspaceCollectionsQuery',
}

// All the GraphqlQueryNames needs to be added here with a Egk attached
export const enum GraphqlEgkQueryNames {
  ORGANIZATION_WORKSPACES_EGK_QUERY = 'OrganizationWorkspacesEgkQuery',
  FREE_WORKSPACES_EGK_QUERY = 'FreeWorkspacesEgkQuery',
  UNIFIED_ORGANIZATION_WORKSPACES_FILTER_EGK_QUERY = 'UnifiedOrganizationWorkspacesFilterEgkQuery',
  ORGANIZATION_WORKSPACES_TOTAL_COUNT_EGK_QUERY = 'OrganizationWorkspacesTotalCountEgkQuery',
  RELATED_WORKSPACES_EGK_QUERY = ' RelatedWorkspacesEgkQuery',
  ELIGIBLE_WORKSPACES_EGK_QUERY = 'EligibleWorkspacesEgkQuery',
  SELECT_PRODUCT_TABLE_EGK_QUERY = 'SelectProductTableEgkQuery',
  USER_LIST_TABLE_EGK_QUERY = 'UserListTableEgkQuery',
  WORKSPACES_COLLECTIONS_EGK_QUERY = 'WorkspaceCollectionsEgkQuery',
  USER_JOIN_SETTINGS_WORKSPACES_EGK_QUERY = 'UserJoinSettingsWorkspacesEgkQuery',
}

interface RequestParams {
  [key: string]: any;
  contextData: InputMaybe<ContextData>;
}

export const generateContextData = (isGraphqlSuccessMetricsEnabled: boolean, queryName: GraphqlQueryNames | GraphqlEgkQueryNames) => {
  if (isGraphqlSuccessMetricsEnabled) {
    return {
      contextData: {
        queryName,
      },
    };
  }

  return {};
};

export const sendContextDataOperationalEvent = (response, requestParams?: Partial<RequestParams>) => {
  if (!requestParams?.contextData) return;

  const { contextData, ...other } = requestParams;

  AnalyticsWebClient.create().sendOperationalEvent(
    responseFetchSizeEvent({
      ...contextData,
      requestParams: {
        ...other,
      },
      size: new Blob([JSON.stringify(response)]).size,
    }),
  );
};
